module.exports = __webpack_public_path__ + "images/icon-copy.c7eb02d1643329d1d35a.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/icon-copy.svg
// module id = gu/3
// module chunks = 13